import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import AddClientPeselNumberDialog from "./AddClientPeselNumberDialog";

const AddClientPeselNumberButton = ({ addClientPeselNumber }) => {
  const [showDialog, setShowDialog] = useState(false);
  const onHandleSave = async (value) => {
    const res = await addClientPeselNumber(value.pesel);
    if (res.success) {
      setShowDialog(false);
    }
  };

  return (
    <>
      <Button
        onClick={() => {
          setShowDialog(true);
        }}
        variant="outlined"
        size="small"
      >
        Przypisz numer PESEL
      </Button>
      {showDialog && (
        <AddClientPeselNumberDialog
          open={showDialog}
          onSave={onHandleSave}
          onCancel={() => setShowDialog(false)}
        />
      )}
    </>
  );
};

AddClientPeselNumberButton.propTypes = {
  addClientPeselNumber: PropTypes.func.isRequired,
};

export default AddClientPeselNumberButton;
